import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    minLength: "Al menos 8 caracteres",
    uppercase: "Al menos una mayúscula",
    number: "Al menos un número",
    hide: "Ocultar contraseña",
    show: "Mostrar contraseña",
    errorMinLength: "La contraseña debe tener al menos 8 caracteres",
    errorUppercase: "La contraseña debe tener al menos una mayúscula",
    errorNumber: "La contraseña debe tener al menos un número",
  },
  en: {
    minLength: "At least 8 characters",
    uppercase: "At least one uppercase letter",
    number: "At least one number",
    hide: "Hide password",
    show: "Show password",
    errorMinLength: "Password must be at least 8 characters long",
    errorUppercase: "Password must contain at least one uppercase letter",
    errorNumber: "Password must contain at least one number",
  },
});
